import { render, staticRenderFns } from "./AnaliseProduto.vue?vue&type=template&id=594feca8&scoped=true"
import script from "./AnaliseProduto.vue?vue&type=script&lang=js"
export * from "./AnaliseProduto.vue?vue&type=script&lang=js"
import style0 from "./AnaliseProduto.vue?vue&type=style&index=0&id=594feca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594feca8",
  null
  
)

export default component.exports